export type SpecialConditions = Nullable<{
  militar: boolean
  hypertense: boolean
  diabetic: boolean
  smoker: boolean
}>

function load(model?: Partial<SpecialConditions> | null): SpecialConditions {
  return {
    militar: model?.militar ?? false,
    hypertense: model?.hypertense ?? false,
    diabetic: model?.diabetic ?? false,
    smoker: model?.smoker ?? false,
  }
}

export const SpecialConditionsEnum = {
  militar: 'MILITAR',
  hypertense: 'HIPERTENSO',
  diabetic: 'DIABETICO',
  smoker: 'FUMADOR',
} as const

const map = {
  toSelectedCondicionesAsegurabilidad(
    model: SpecialConditions
  ): SiteApiSchema<'FillClienteByAseguradoViewModel`5'>['selectedCondicionesAsegurabilidad'] {
    const list: string[] = []
    if (model.diabetic) list.push(SpecialConditionsEnum.diabetic)
    if (model.hypertense) list.push(SpecialConditionsEnum.hypertense)
    if (model.militar) list.push(SpecialConditionsEnum.militar)
    if (model.smoker) list.push(SpecialConditionsEnum.smoker)
    return list.join(',')
  },
}

export const SpecialConditions = {
  load,
  map,
}
